import { editUserColumnsVisibility } from "../services/UserService";

const handleOnViewColumnsChange = async (columnName, action, tableName) => {
    const visibility = JSON.parse(localStorage.getItem(tableName)) || {};
    const newVisibility = {
        ...visibility,
        [columnName]: action === "add",
    };
    localStorage.setItem(tableName, JSON.stringify(newVisibility));
    const userData = JSON.parse(localStorage.getItem('userData'));
    try {
        await editUserColumnsVisibility({tableName, visibility: JSON.stringify(newVisibility)}, userData?.uuid);
    } catch (err) {}
}

const displayColumn = (columnName, tableName) => {
    const storedVisibility = JSON.parse(localStorage.getItem(tableName)) || {};
    return storedVisibility[columnName] !== undefined ? storedVisibility[columnName] : true;
};

export { handleOnViewColumnsChange, displayColumn };
